// extracted by mini-css-extract-plugin
export default {"root":"MultiSelectTransfer_root__HET78","buttons":"MultiSelectTransfer_buttons__lMZOT","item":"MultiSelectTransfer_item__5IDm4"};